import React from "react";
import MainLayout from "../../MainLayout.tsx";
import colors from "../../../constants/colors.ts";
import {
  testimonials,
} from "../../../constants/homepage.constants.ts";
import Testimonials from "../../../components/slideshow/testimonials.component.tsx";
import CoverListsGrid from "../../../components/grids/coverListsGrid.component.tsx";
import { coverListGridItems } from "../../../constants/lists.constants.ts";

const Section6: React.FC = () => {
  return (
    <MainLayout backgroundColor={colors.CYAN_E6FFFF}>
      {coverListGridItems?.map((item, index) => (
        <CoverListsGrid
          key={index}
          title={item?.title}
          cover={item?.cover}
          list={item?.items}
        />
      ))}
    </MainLayout>
  );
};

export default Section6;
